import Component from '@ux/component';
import React from 'react';
import PropTypes from 'prop-types';
import shapes from './shapes';
import CreditCard from '@ux/icon/credit-card';
import Alert from '@ux/icon/alert';
import DropRight from '@ux/icon/drop-right';

class NotificationListItem extends Component {
  constructor() {
    super(...arguments);
    this.renderNotificationLink = this.renderNotificationLink.bind(this);
    this.renderStaticNotification = this.renderStaticNotification.bind(this);
  }

  renderNotificationLink(notification, href, classes, icon) {
    const { content, eids } = notification;
    return (
      <a
        target='_blank'
        rel='noopener noreferrer'
        href={ href }
        data-eid={ eids && eids.click }
        className={ classes }>
        <span>{ icon }</span>
        { content }
        <span className='icon-notification-link'>
          <DropRight />
        </span>
      </a>
    );
  }

  renderStaticNotification(notification, classes, icon) {
    return (
      <span className={ this.classNames(classes, 'no-link') }>
        { icon }
        { notification.content }
      </span>
    );
  }

  render() {
    const { notification, index } = this.props;
    const { priority, subcategory } = notification;
    const type = subcategory === 'FailedBilling' ? 'creditCardExpiration' : '';
    const priorityClassMap = {
      Medium: 'medium',
      High: 'high'
    };
    const priorityClass = priorityClassMap[priority] || '';
    const priorityLabelClassName = this.classNames(
      'priority',
      priorityClass,
      type
    );
    const classes = 'notifications-list-item font-base';
    const { link } = notification;
    const icon = type === 'creditCardExpiration' ? <CreditCard /> : <Alert />;

    return (
      <li className={ classes } id={ `notifications-list-item-${index}` }>
        { link
          ? this.renderNotificationLink(
            notification,
            link,
            priorityLabelClassName,
            icon
          )
          : this.renderStaticNotification(
            notification,
            priorityLabelClassName,
            icon
          )}
      </li>
    );
  }
}

NotificationListItem.propTypes = {
  notification: shapes.notification.isRequired,
  index: PropTypes.number
};

export default NotificationListItem;
